// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:26.310324
var courses = [
    {
        "course_id": "317CC2E6-758B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP - Emergency Presentations Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "The Emergency Presentations Bundle prepares emergency and urgent care providers for the full range of complaints that walk through the door \u2014 the common, the easily missed, and the ones that deteriorate fast. Taught by practicing experts in emergency care, these courses move from diagnostic fundamentals through the recognition and management of time-critical conditions, and include the screening skills that surface what patients don't volunteer.\r\n18 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33E9E82A-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - Emergency Presentations - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - Emergency Presentations Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "31887D19-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Basic EKG Interpretation for the ENP",
                "course_type": 1,
                "author_information": "Jolene Traum, ENP-C",
                "description": "This course focuses on basic anatomy, electrical pathways, components of the 12 lead EKG, and EKG patterns. This course will go over recognition of EKG patterns, causes, and meanings.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the electrical pathway of the heart</li>\r\n    <li>Describe the components of a normal 12 lead EKG</li>\r\n    <li>Relate components of EKG to cardiac anatomy</li>\r\n    <li>Recognize patterns, meanings, and potential causes of EKGs</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "551FF8E5-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Screening for IPV in the ED",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, ENP-C, FNP-C and\r\nHilary Ashton Glover, DNP, FNP-C, ENP-C, SANE-A",
                "description": "This webinar will increase awareness of Intimate Partner Violence impact, warning signs and resources",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify prevalence of IPV</li>\r\n    <li>Identify 3 risk factors for IPV</li>\r\n    <li>Identify 3 signs &amp; symptoms of IPV</li>\r\n    <li>Describe the screening guidelines for IPV</li>\r\n    <li>Identify 2 interviewing techniques for IPV</li>\r\n    <li>Identify 2 legal considerations related to IPV</li>\r\n    <li>Discuss the mental health impact of IPV</li>\r\n    <li>Identify 1 barrier and 1 solution related to IPV</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB3023AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Knowledge Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0E54130C-E117-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Venous Thromboembolism: Initiation of Pulmonary Embolism Response Teams (PERT)",
                "course_type": 1,
                "author_information": "Speaker: Jolene Donald, AG-ACNP, ENP, FNP, MSN, RN",
                "description": "This course will dive into the pathophysiology, risk stratification, and work-up of patients related to PE and DVT. PERT teams will be discussed including the benefits to both the patient and the hospital.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify 3 signs and symptoms of PE and DVT</li>\r\n    <li>Identify diagnostic studies for both PE and DVT</li>\r\n    <li>Identify and utilize 3 risk stratification tools to assist in identification of patient at higher risk for PE who require further work-up</li>\r\n    <li>Name 5 reasons PERTs benefit patients and the hospital</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4FDB4F21-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Process Improvement",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4D1A9C4B-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Measles: A Rash from the Past",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "The course will examine the current Measles outbreak and implications for Emergency and Urgent Care Providers.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Examine Measles epidemiology and pathophysiology.</li>\r\n    <li>Discuss Measles diagnostics and plan of care pearls.</li>\r\n    <li>Identify complications associated with Measles.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C6C823A0-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Nail Procedures for ED & Urgent Care Providers",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, FNP-C, ENP-C",
                "description": "This course will take the viewer through common nail procedures that present to EDs and urgent care centers. The course will discuss the procedures, including digital blocks, preparation considerations, contraindications, and more.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify nail procedures commonly performed in the ED and Urgent Care settings.</li>\r\n    <li>Discuss methods for placing a digital block.</li>\r\n    <li>Understand indications and management of various nail procedures.</li>\r\n    <li>Identify important considerations for practice, including scope, consultations, and referrals.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "800304EE-DF17-F111-99AB-005056A70840",
                "course_version": 2,
                "name": "To See or Not to See: Eye Trauma",
                "course_type": 1,
                "author_information": "Karen O\u2019Connell Schill, DNP, FNP-BC, ENP-C, CEN, CFRN, NREMT & Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "This course evaluates different types of eye trauma. Evaluation tools and treatment options for various eye trauma will be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understanding the different types of eye trauma</li>\r\n    <li>Describe evaluation tools and assessment tools</li>\r\n    <li>List appropriate treatment options for each eye trauma injury</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6527E533-CFC9-E511-82AF-005056B150D3",
                        "course_category_name": "Ear, Eye, Nose and Throat Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "7145BC2B-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Agricultural Illnesses & Injuries",
                "course_type": 1,
                "author_information": "Travis McCall PhD, APRN, CCP",
                "description": "Down on the Farm: Agricultural Illnesses and Injuries\u201d will describe illnesses and injuries among farm workers who may present to the emergency department. Content will include the incidence, diagnosis, and management of environmental exposures, vector-borne illnesses, toxicologic poisoning, and mechanical injuries that may occur among farm workers. Social determinants of health that may affect the care and health of farm workers will also be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the epidemiology of illnesses and injuries among farm workers.</li>\r\n    <li>Understand the illnesses and injuries that may result from environmental, toxicologic, and mechanical exposures.</li>\r\n    <li>Discuss evidence-based care and treatment of patients who suffer farm-related illnesses or injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "38E8CB6F-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Mind the Gap: Toxic Alcohols",
                "course_type": 1,
                "author_information": "Nancy Denke, DNP, ACNP-BC, FNP-BC, FAEN, CEN, CCRN",
                "description": "When we consider alcohol toxicity as a diagnosis in the altered patient, the first thing that comes to mind is ethyl alcohol intoxication. However, it is important to understand that any alcohol, when consumed in sufficient quantity, can be toxic. Other \u201ctoxic alcohols\u201d we frequently overlook include methanol, ethylene glycol, propylene glycol, and isopropanol (isopropyl alcohol). In this presentation, we examine 3 different scenarios: an intentional overdose, an agitated patient who will not give you a history, and an inebriated individual with numerous medical and psychiatric histories that you have \u201cno clue what is going on with them.\u201d. And lastly, the simple \u201cvery drunk.\u201d. We will touch on propylene glycol, which is seen mainly in an inpatient setting with IV infusions that contain propylene glycol as an additive but must be \u201cconsidered\u201d in any patient. It is our job as providers to identify, treat, and manage the \u201crare\u201d toxic alcohols that have potentially life-threatening diagnoses. And that is not so easy!",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify the clinical and laboratory clues to recognizing toxic alcohol poisonings</li>\r\n    <li>Describe the goals of management and treatment in toxic alcohol poisoning</li>\r\n    <li>Examine the time-sensitive management actions for these poisonings</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "54141F89-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Non-Fatal Strangulation",
                "course_type": 1,
                "author_information": "Heidi Gilbert MSN, RN, CEN, TCRN, SANE",
                "description": "All forms of intimate partner violence are detrimental to the overall wellness of our patients, some are even criminal. Strangulation is different, and much worse. Men who strangle are more likely to kill their victims, kill police, and perpetrate mass shootings. Strangulation is one of the few near fatal events that often leave little or no physical findings on patients presenting to the ED, urgent care, or clinic settings. What is the mechanism of injury and why is strangulation so deadly? What are the obvious and occult signs and symptoms the clinician should look for? What\u2019s the best (and worst) way to gather a patient history and document, and how does all of this relate to the medical exception to hearsay? \r\n \r\nThis is an emotional and knowledge packed 50-minute presentation. I am passionate about this topic having lost my sister in 2013 to domestic violence homicide. I\u2019ll share with you what I wish I\u2019d known and what I wish I\u2019d said. This presentation will give you the knowledge and tools to become a gladiator for victims of violence in your clinical setting.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the mechanism of injury in strangulation</li>\r\n    <li>Summarize the anoxic progression experienced during strangulation</li>\r\n    <li>Identify trauma-informed interviewing techniques and why this is important to victims of trauma.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2E45119E-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Not-so-Sweet Hidden Threat of DKA",
                "course_type": 1,
                "author_information": "Rachel Helms, DNP, APRN, AGACNP-BC, FNP-BC, ENP-C \r\nJoni Winter, DNP, CRNP, FNP-BC, AGACNP-BC, ENP-C, CVNP-BC",
                "description": "Euglycemic diabetic ketoacidosis (EDKA) is an uncommon but life-threatening process identified in patients with type 1 and 2 diabetes. The condition is characterized by normoglycemia in the setting of an anion gap, metabolic ketoacidosis.  There are several risk factors for developing EDKA; however, increased risks are linked to SGLT2 inhibitor use, type 1 diabetes, and bariatric surgeries secondary to prolonged perioperative fasting.\r\n \r\nEDKA occurs as serum insulin levels decrease and excess counter regulatory hormones develop due to a carbohydrate deficit. The resulting increased glucagon/insulin ratio causes lipolysis, increased free fatty acids, and ketoacidosis.\r\n \r\nUnfortunately, the normal glucose level causes the diagnosis of EDKA to be delayed in almost 50% of patients. Therefore, EDKA should be included in the differential list for all patients with the risk factors and symptoms mentioned above.\r\n \r\nIn order to increase awareness and understanding of EDKA, this presentation will utilize a case study format to illustrate a patient who presents to the emergency department and is ultimately diagnosed with often-missed diagnosis.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize risk factors associated with euglycemic diabetic ketoacidosis (EDKA).</li>\r\n    <li>Discuss the pathophysiology of EDKA.</li>\r\n    <li>Identify the typical presenting symptoms and diagnostic criteria for EDKA.</li>\r\n    <li>Develop an appropriate plan of care for a patient diagnosed with EDKA.       </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Endocrine Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6B692541-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "BRASH Syndrome Identification & Management",
                "course_type": 1,
                "author_information": "Jacob Miller, DNP, MBA, ACNP, ENP-C, CNS, NRP",
                "description": "This presentation will present a patient scenario with a constellation of bradycardia, renal failure, AV nodal blockade, shock, and hyperkalemia (BRASH Syndrome) and highlight considerations in identifying and managing these patients in the emergency setting. Pharmacotherapeutic content will involve the role of pharmacologic agents as a contributing mechanism (i.e., AV nodal blocking agents) in addition to the pharmacotherapeutic management of BRASH Syndrome.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the pathophysiology of BRASH Syndrome and articulate the synergy between each of its components</li>\r\n    <li>Formulate a treatment plan to rapidly intervene to prevent morbidity and mortality in a patient with BRASH Syndrome</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                        "course_category_name": "Cardiac Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BA92725B-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Fundamentals of CXR",
                "course_type": 1,
                "author_information": "Ronald Ray, DNAP, CRNA, FNP-C, ENP-C",
                "description": "This course provides an introduction to the interpretation of chest radiographs (CXR). Learners will be guided through a systematic approach to reading CXR films to ensure consistent and accurate evaluation. The course reviews normal thoracic anatomy as visualized on chest radiographs, helping participants recognize expected structures and variations. It also introduces common disease patterns seen on CXR, enabling learners to identify and describe radiographic findings associated with a range of pulmonary and thoracic conditions.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe a systematic approach to reading CXR films.\r\n    </li>\r\n    <li>Describe normal anatomy as viewed on a CXR film.</li>\r\n    <li>Describe various disease patterns as viewed on CXR films.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4C00C9BD-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Peripheral Vascular Injuries",
                "course_type": 1,
                "author_information": "Kelley Scott, DNP, ENP-C, FNP-BC",
                "description": "Peripheral vascular injuries can be devastating, threatening to life and or limb. These injuries may occur as a result of an accident, from a motor vehicle, a fall, an athletic injury, or from an assault. Individuals with blunt and penetrating trauma are at risk for peripheral vascular injury. Peripheral vascular injuries can present a challenge for healthcare providers. An injury to a vital blood vessel can be subtle and difficult to identify. Delay of diagnosis may lead to complicating hemorrhage, aneurysm formation, arteriovenous fistulization, and gangrene.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Define Peripheral Vascular Injury</li>\r\n    <li>Assessment Findings/Presentation</li>\r\n    <li>Diagnostic Evaluation</li>\r\n    <li>Criteria for Scoring Peripheral Vascular Injuries</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Vascular Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.9,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "78FF3F4D-5017-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Acute Alcohol Withdrawal in the ED: Navigating the Storm",
                "course_type": 1,
                "author_information": "Sharon Rainer, PhD, APRN, ENP-C, FNP-BC, PMHNP-BC",
                "description": "Acute alcohol withdrawal is a potentially life-threatening condition that requires prompt recognition and management to prevent severe complications such as seizures, delirium tremens (DTs), and cardiovascular instability. Effective management of acute alcohol withdrawal in the ED involves prompt identification, appropriate use of pharmacological and supportive treatments, and careful monitoring. Early intervention and proper follow-up are crucial for reducing complications and improving patient outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Prepare emergency clinicians to accurately identify and assess the severity of acute alcohol withdrawal using clinical tools and symptom evaluation to ensure timely and effective intervention.\r\n    </li>\r\n    <li>Provide a detailed overview of current best practices for managing acute alcohol withdrawal, including pharmacological therapies and supportive care, to mitigate withdrawal symptoms and prevent complications.\r\n    </li>\r\n    <li>Develop strategies for effective patient disposition, including risk stratification and planning for appropriate next level of care</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3EB86657-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Trauma in the ED",
                "course_type": 1,
                "author_information": "Tiffany Andrews, MS, ACNP-BC, ENP-C",
                "description": "Accidental and traumatic injuries remain one of the leading causes of death worldwide, accounting for 5.8 million deaths annually and a large percentage of ED evaluations. Increasing disease severity creates an environment that makes patient care difficult. Throughout this presentation, we will discuss the initial evaluation and management of trauma patients in the ED and how to identify potential traumatic injuries based on mechanism of injury.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe mechanism of injury and triage of trauma patients in the Emergency Department</li>\r\n    <li>Describe the initial evaluation and management of the patient with traumatic injuries in the Emergency Department</li>\r\n    <li>Identify the different types of trauma seen in the Emergency Department</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5636B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Trauma Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FC393F6B-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Top 5 Finger Complaints in Emergency Care",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "Using a case-based approach, this presentation will review five common finger complaints encountered in emergency care settings: Flexor Tenosynovitis, Felon, Paronychia, Subungal Hematoma, and Herpetic Whitlow. Some of these are minor and some can have significant problems if not managed appropriately. Assessment findings and management options will be reviewed during this presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recall key aspects of performing a hand and finger assessment.</li>\r\n    <li>Identify five common finger complaints encountered in emergency care settings.</li>\r\n    <li>Recall the classic presentations of select finger emergencies.</li>\r\n    <li>Describe pharmacologic options for managing select finger emergencies</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DA6AFC27-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Screening for Delirium in Patients with Serious Mental Illness & Dementia",
                "course_type": 1,
                "author_information": "Sharon Rainer, PhD, APRN, ENP-C, FNP-BC, PMHNP-BC",
                "description": "The aim of this presentation is to provide a thorough understanding of how to effectively screen for delirium in patients with serious mental illness (SMI) or dementia in the emergency department (ED). Patients with SMI, such as schizophrenia or bipolar disorder, are at increased risk for delirium, which can complicate their clinical presentation and management. Early detection is crucial for preventing adverse outcomes and ensuring appropriate care. The importance of addressing underlying causes, stabilizing the patient, and employing supportive measures will be discussed. In addition, pharmacologic and non-pharmacologic interventions while considering the impact of these treatments on both delirium and pre-existing psychiatric conditions will be emphasized.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Prepare emergency clinicians to distinguish delirium from psychosis and dementia, focusing on identifying key clinical features and using appropriate screening tools to ensure accurate diagnosis.</li>\r\n    <li>Provide a practical guide for implementing screening protocols for delirium in patients with SMI and dementia, including the use of validated tools.</li>\r\n    <li>Outline strategies for managing patients diagnosed with delirium, including addressing underlying causes, stabilizing symptoms, and coordinating care with multidisciplinary teams.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                        "course_category_name": "Psychiatric Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0298E844-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "That Bites: Snakes, Stings, and other Things!",
                "course_type": 1,
                "author_information": "Ashton Glover, DNP, FNP-C, ENP-C, SANE-A",
                "description": "In this presentation, I discuss the evaluation and management of animal bites, focusing on dog bites and snake bites. I cover the initial assessment, wound care, post-exposure prophylaxis, and criteria for surgical consultation. Viewers are instructed on important considerations such as rabies prophylaxis and antibiotic prophylaxis. Action requested includes understanding the guidelines for managing different types of animal bites.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the evaluation of a patient with an animal bite or sting.</li>\r\n    <li>Describe the presentation of a patient exhibiting venom toxicity</li>\r\n    <li>Review management strategies for animal bites and stings</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.4,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];